import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import {
    CLEAR_SUPPLIER_CONDITIONS,
    RECEIVE_SUPPLIERS,
    RECEIVE_SUPPLIER_CONDITIONS,
    REQUEST_SUPPLIERS,
    REQUEST_SUPPLIERS_COMPLETE,
    RESET_SUPPLIERS,
} from '../actions/supplier-actions';
import { Supplier } from '../models/supplier';
import { TermsAndConditions } from '../models/terms-and-conditions';

export interface SupplierReducerState {
    flat: PaginatedResponse<Supplier>;
    termsAndConditions?: TermsAndConditions;
    requesting: boolean;
    supplier?: Supplier;
}

const initialSupplierReducerState: SupplierReducerState = {
    flat: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const supplierReducer = (
    state: SupplierReducerState = initialSupplierReducerState,
    action: AnyAction
): SupplierReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case REQUEST_SUPPLIERS: {
            return {
                ...state,
                requesting: true,
            };
        }

        case REQUEST_SUPPLIERS_COMPLETE: {
            return {
                ...state,
                requesting: false,
            };
        }

        case RECEIVE_SUPPLIERS: {
            const newSuppliers = { ...rest['suppliers'] };
            if (rest['append']) {
                const items = [...state.flat.items, ...rest['suppliers'].items];
                newSuppliers.items = items;
            }
            return {
                ...state,
                flat: newSuppliers,
                requesting: false,
            };
        }

        case RESET_SUPPLIERS: {
            return {
                ...initialSupplierReducerState,
            };
        }

        case RECEIVE_SUPPLIER_CONDITIONS: {
            return {
                ...state,
                termsAndConditions: action['termsAndConditions'],
            };
        }

        case CLEAR_SUPPLIER_CONDITIONS: {
            return {
                ...state,
                termsAndConditions: undefined,
            };
        }

        default: {
            return state;
        }
    }
};
